export default {
  // Used icon in rms
  rms_arrow_right: 'mdi-arrow-right',
  rms_dot_horizontal: 'mdi-dots-horizontal',
  rms_meter: 'mdi mdi-speedometer',
  rms_edit: 'mdi-pencil',
  rms_delete: 'mdi-delete',
  rms_agreement: 'mdi-file-document-box-outline',
  rms_upload: 'mdi-upload',
  rms_emoticon_sad: 'mdi-emoticon-sad',
  rms_visibility: 'mdi-eye-outline',
  rms_account_outline: 'mdi-account-box-outline',
  rms_tag: 'mdi-tag',
  rms_map: 'mdi-map-marker',
  rms_setting: 'mdi-settings',
  rms_translate: 'mdi-google-translate',
  rms_media: 'mdi-play-box-outline',
  rms_media_link: 'mdi-link-variant',
  rms_menu_down: 'mdi-menu-down',
  rms_logout: 'mdi-exit-to-app',
  rms_leave_impersonation: 'mdi-exit-to-app',
  rms_image_not_found: 'mdi-file-image',
  rms_help_circle: 'mdi-help-circle',
  rms_company_select_icon: 'mdi-login-variant',
  rms_process_check: 'mdi-progress-check',
  rms_company: 'mdi-office',

  rms_bell: 'mdi-bell',
  rms_firefox: 'mdi-firefox',
  rms_chrome: 'mdi-google-chrome',
  rms_safari: 'mdi-apple-safari',
  rms_android_browser: 'mdi-android',

  rms_session_device_desktop: 'mdi-laptop',
  rms_session_device_mobile: 'mdi-cellphone-android',
  rms_session_device_tablet: 'mdi-tablet',

  rms_session_list: 'mdi-view-list',
  rms_refresh: 'mdi-refresh',
  rms_receive_money: 'mdi-arrow-bottom-left',
  rms_login: 'mdi-login',
  rms_register: 'mdi-account-plus',
  rms_network_level1: 'mdi-numeric-1-box-outline',
  rms_network_level2: 'mdi-numeric-2-box-outline',
  rms_network_commission: 'mdi-cash',
  rms_network_count: 'mdi-account-network',
  rms_copy: 'mdi-file-multiple',
  rms_cash_balance: 'mdi-cash',
  rms_bank: 'mdi-bank',
  rms_txn_status_approved: 'mdi-checkbox-marked-circle',
  rms_txn_status_freezed: 'mdi-lock',
  rms_txn_status_prepare: 'mdi-pencil-box-outline',
  rms_txn_status_cancel: 'mdi-cancel',
  rms_video: 'mdi-video',

  rms_user_recharge: 'mdi-cash-multiple',
  rms_mobile: 'mdi-cellphone',
  rms_email: 'mdi-email',

  rms_film: 'mdi-film',
  rms_film_strip: 'mdi-filmstrip',
  rms_movie: 'mdi-movie',
  rms_video: 'mdi-video',

  rms_idproof_add: 'mdi-account-badge',
  rms_idproof_business: 'mdi-account-badge',
  rms_idproof_expiry: 'mdi-calendar',
  rms_id_proof_default: 'mdi-image-plus',
  rms_id_proof_pdf: 'mdi-file',
  /**not found in mdi */
  rms_locale: 'language',
  rms_logout: 'mdi-exit-to-app',

  rms_happy: 'mdi-check-circle-outline',
  rms_sad: 'mdi-alert',

  rms_close: 'mdi-close',
  rms_date: 'mdi-calendar',
  rms_create: 'mdi-plus',

  rms_go_back: 'mdi-chevron-left',
  rms_clear: 'mdi-close-circle-outline',

  rms_credit_tree: 'mdi-chevron-up',
  rms_debit_tree: 'mdi-chevron-down',

  rms_send_money: 'mdi-arrow-top-right',
  rms_send_money_to_registered: 'mdi-wallet',
  rms_send_money_to_unregistered: 'mdi-account-question',
  rms_send_money_in_bank: 'mdi-bank-transfer-in',

  rms_recharge_wallet: 'mdi-plus-box',

  rms_get_money: 'mdi-arrow-bottom-left',
  rms_get_money_request_money: 'mdi-arrow-bottom-left',
  rms_recharge_wallet_topup: 'mdi-wallet-outline',
  rms_get_money_cash_pickup: 'mdi-cash',

  rms_partner: 'mdi-account-star-outline',
  rms_partner_deposit: 'mdi-cash-register',
  rms_partner_withdraw: 'mdi-cash-multiple',
  rms_user_rewards: 'mdi-gift',
  rms_partner_commission: 'mdi-gift',

  rms_wallet: 'mdi-wallet',
  rms_wallet_balance: 'mdi-wallet',
  rms_wallet_list_item: 'mdi-wallet-outline',
  rms_wallet_add: 'mdi-plus-box',
  rms_wallet_status: 'mdi-lock',
  rms_wallet_currency: 'mdi-coin',
  rms_wallet_profile: 'mdi-account-box',
  rms_wallet_idproofs: 'mdi-file-account',
  rms_wallet_bank_account: 'mdi-bank',
  rms_wallet_child: 'mdi-account-child',
  rms_wallet_switcher: 'mdi-wallet',
  rms_icon_missing: 'mdi-image-broken',

  rms_send_moeny_qr_scan: 'mdi-qrcode',

  rms_account: 'mdi-account-box',
  rms_dashboard: 'mdi-home',
  rms_company_dashboard: 'mdi-view-dashboard',
  rms_transactions: 'mdi-format-list-checkbox',
  rms_scan: 'mdi-qrcode-scan',
  rms_locked: 'mdi-lock',
  rms_network: 'mdi-trending-up',
  rms_countdown: 'mdi-timer',
  rms_goback: 'mdi-chevron-left',
  rms_setpin: 'mdi-shield-lock',
  rms_next: 'mdi-chevron-right',
  rms_tnc: 'mdi-file-check',
  rms_user_profile: 'mdi-account-details',
  rms_onboarding_welcome: 'mdi-emoticon-excited-outline',

  rms_wallet_approved: 'mdi-check-decagram',
  rms_wallet_awaited: 'mdi-timer-sand',
  rms_wallet_freeze: 'mdi-book-lock',
  rms_wallet_block: 'mdi-block-helper',
  rms_wallet_closed: 'mdi-close-box',

  rms_rule_is_enabled: 'mdi-checkbox-marked-circle',
  rms_rule_is_disabled: 'mdi-cancel',
  rms_rule_reset_filters: 'mdi-refresh',
  rms_rule_arrow_upward: 'mdi-arrow_upward',

  rms_message_list: 'mdi-bell',
  rms_rules: 'mdi-format-list-checkbox',
  rms_country_combinations: 'mdi-format-list-checkbox',
  rms_maintenance: 'mdi-cloud-off-outline',

  rms_visibility_off: 'mdi-eye-off',
  rms_billing: 'mdi-credit-card',
  rms_clock: 'mdi-clock',
  rms_sync: 'mdi-sync',
  rms_check: 'mdi-check',
  rms_media_download: 'mdi-download',
  rms_otp: 'mdi-account-key',
  rms_country: 'mdi-flag',
  rms_rights: 'mdi-star-circle',
  rms_save: 'mdi-content-save',
  rms_delivery_profile: 'mdi-briefcase',
  rms_duplicate: 'mdi-content-copy',
  rms_move_media: 'mdi-video-switch',
  rms_set_as: 'mdi-image-album',
  rms_image: 'mdi-file-image',
  rms_switch: 'mdi-apps',
  rms_company_members: 'mdi-account-multiple',
  rms_activities: ' mdi-history',
  rms_encoding_status_: 'mdi-progress-alert',
  rms_encoding_status_NONE: 'mdi-progress-alert',
  rms_encoding_status_REQUESTED: 'mdi-progress-wrench',
  rms_encoding_status_ENCODING: 'mdi-progress-check',
  rms_encoding_status_ENCODED: 'mdi-video-check',
  rms_encoding_status_ERROR: 'mdi-progress-close',
  rms_id: 'mdi-numeric',
  rms_password: 'mdi-account-key',
  screener_back: 'mdi-arrow-left',
  screener_next: 'mdi-arrow-right',
  screener_revenue: 'mdi-chart-line',
  screener_group_ticket: 'mdi-cards-outline',
  coupons_icon: 'mdi-tag-plus',
  currency_usd: 'mdi-currency-usd',
  screener_sales: 'mdi-credit-card-multiple',
  screener_types: 'mdi-filter-variant',
  screener_money: 'mdi-cash',
  enterprise: 'mdi-star-circle',
  rms_live:'mdi-access-point',
  mew_theater:'mdi-theater',
  rms_navigation: 'mdi-near-me',
  rms_print: "mdi-printer",
  rms_blank_circle: "mdi-checkbox-blank-circle",
  analytics_icon: 'mdi-chart-areaspline',
  rms_group: "mdi-group",
  screener_menu_down:"mdi-menu-down",
  chart_bar:"mdi-chart-bar",
  credit_card_sync: "mdi-account-cash-outline",
  mew_widgets:"mdi-widgets",
  mew_apps:'mdi-apps',
  company_filmmakers: 'mdi-video-account',
  netfest_programs:'mdi-calendar-multiple'
};
